// src/hooks/useUserEmail.js
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { firebaseApp } from "../firebase/firebaseApp";

/**
 * Returns { email, loading }
 * - Watches Firebase auth state.
 * - Prefers Firestore-stored email at: lungform_users/{uid}.email
 * - Falls back to user.email if present.
 */
export function useUserEmail() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth(firebaseApp);
    const db = getFirestore(firebaseApp);

    const unsub = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          setEmail("");
          return;
        }
        const ref = doc(db, "lungform_users", user.uid);
        const snap = await getDoc(ref);
        const fsEmail = snap.exists() ? snap.data()?.email : undefined;
        setEmail(fsEmail || user.email || "");
      } catch (err) {
        // don’t crash UI; just fall back if possible
        console.error("useUserEmail error:", err);
        setEmail(user?.email || "");
      } finally {
        setLoading(false);
      }
    });

    return () => unsub();
  }, []);

  return { email, loading };
}
